import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';
import type {
  OnInit
} from '@angular/core';

@Component({
    selector: 'ppl-popover-dropdown',
    templateUrl: './popover-dropdown.component.html',
    styleUrls: ['./popover-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplPopoverDropdownComponent implements OnInit {

  @Input() @HostBinding('style.width.px') width: boolean | number;
  @Input() connectToElement?: HTMLElement;

  ngOnInit(): void {
    if (this.connectToElement) {
      this.width = this.connectToElement.offsetWidth;
    }
  }
}
